import { call, put, takeLatest } from "redux-saga/effects";
import { httpRequest } from "../../utils/networkCalls";
import { updateLoadingStatus } from "../Loader/LoaderReducer";
import {
    FETCH_ALL_TEMPS_FROM_DB,
    FETCH_SUBSCRIPTION_DETAILS_OF_USER,
    initDropDownLists,
    SAVE_DATA_TO_DB,
    SAVE_DATA_TO_DB_FIRST_TIME,
    setFormSchema,
    setFormSchemaFirstTime,
    setTypesAndEvents,
    updateSubscrbedDetail,
} from "./FlyersReducer";
import axios from "axios";

async function fireMutltipleAPIs(apiArr) {
    let promises = [];
    for (let i = 0; i < apiArr.length; i++) {
        promises.push(
            httpRequest(apiArr[i].url, apiArr[i].method, apiArr[i].body)
        );
    }

    return Promise.all(promises);
}

export function* fetchSubscriptionDetialsOfUser(action) {
    const subRes = yield call(
        httpRequest,
        `/user-subscription/user-active-subscriptions`,
        "post",
        { email: action.payload.email }
    );

    const subsData = subRes.data[0];

    yield put(updateSubscrbedDetail(subsData));
}

export function* fetchTempsFromDb(action) {
    try {
        yield put(updateLoadingStatus(true));
        const tempRes = yield call(httpRequest, "/banner_templates", "get");

        let formSchemaRes = {};
        if (action.payload.orderId) {
            const formRes = yield call(
                httpRequest,
                `/banner_order/${action.payload.orderId}`,
                "get"
            );
            formSchemaRes = { ...formRes };
        }

        const typesAndEvents = {};
        if (tempRes?.status == "success") {
            let sortedTemps = tempRes?.data.sort((a, b) => a.id - b.id);
            sortedTemps.forEach((element) => {
                if (typesAndEvents[element.banner_type] == undefined) {
                    typesAndEvents[element.banner_type] = {};
                }
                if (
                    typesAndEvents[element.banner_type][element.category] ==
                    undefined
                ) {
                    typesAndEvents[element.banner_type][element.category] = [];
                }
                typesAndEvents[element.banner_type][element.category].push(
                    element
                );
            });
        }

        yield put(updateLoadingStatus(false));
        yield put(
            setTypesAndEvents({
                typesAndEvents,
                allTemps: tempRes.data,
                formRes: formSchemaRes,
            })
        );
        // yield put(initDropDownLists());
    } catch (e) {
        throw e;
    }
}

export function* sendDataToDBFirstTime(action) {
    try {
        let { oid, name, email, eventType, category, isFreeTrial } =
            action.payload.formSchema;

        let formSchema = {
            oid,
            stype: "banner",
            name,
            email,
            bannerRes: { finalImgUrl: "", dynaurl: "" },
            status: "",
            satisfactionLevel: "",
            leadType: "",
            tid: "",
            eventType,
            category,
            template_data: [],
        };

        let tempFormSchema = {
            name,
            email,
            stype: "banner",
            orderID: oid,
            isFreeTrial: isFreeTrial,
            number_of_img: "1",
        };

        // let res = yield call(
        //     httpRequest,
        //     "/banner_order/update",
        //     "post",
        //     formSchema
        // );

        let apiArray = [
            { url: "/banner_order/update", method: "POST", body: formSchema },
            { url: "/temp_order", method: "POST", body: tempFormSchema },
        ];
        // let

        let res = yield call(fireMutltipleAPIs, apiArray);

        yield put(setFormSchemaFirstTime({ formSchema: res[0].data }));
    } catch (e) {
        console.log(e.message);
    }
}

export function* sendDataToDB(action) {
    try {
        let formSchema = { ...action.payload.formSchema };
        // let res = yield call(
        //     httpRequest,
        //     "/banner_order/update",
        //     "post",
        //     action.payload.formSchema
        // );

        let tempFormSchema = {
            name: formSchema.name,
            email: formSchema.email,
            stype: "banner",
            orderID: formSchema.oid,
            isFreeTrial: formSchema.isFreeTrial,
            number_of_img: "1",
        };

        let apiArray = [
            { url: "/banner_order/update", method: "POST", body: formSchema },
            { url: "/temp_order", method: "POST", body: tempFormSchema },
        ];

        let res = yield call(fireMutltipleAPIs, apiArray);

        yield put(setFormSchema({ formSchema: res[0].data }));
    } catch (e) {
        console.log("in saga this is not working", e);
        throw e;
    }
}

export function* sagaFlyers() {
    yield takeLatest(
        FETCH_SUBSCRIPTION_DETAILS_OF_USER,
        fetchSubscriptionDetialsOfUser
    );
    yield takeLatest(FETCH_ALL_TEMPS_FROM_DB, fetchTempsFromDb);
    yield takeLatest(SAVE_DATA_TO_DB, sendDataToDB);
    yield takeLatest(SAVE_DATA_TO_DB_FIRST_TIME, sendDataToDBFirstTime);
}
